<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)" (remove)="onRemove($event)" (edit)="onEdit($event)" [columns]="columns"
                  [dataProvider]="organisationCustomerService" [title]="title" [searchColumns]="searchColumns"
                  [searchAll]="true"></data-table>
</page-content>
